;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="be1bfe55-d56e-44b6-9e98-e5b502fa6af9",e._sentryDebugIdIdentifier="sentry-dbid-be1bfe55-d56e-44b6-9e98-e5b502fa6af9")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './DarkOverlay.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

const DarkOverlay = ({ show }) => {
    const [portalElement, setPortalElement] = useState(null);
    useEffect(() => {
        const element = document.querySelector('#portal-header-flyout') ??
            document.createElement('div');
        element.id = 'portal-header-flyout';
        document.body.appendChild(element);
        setPortalElement(element);
        return () => {
            // Cleanup function to remove portal on unmount
            if (element) {
                document.body.removeChild(element);
            }
        };
    }, []);
    if (!portalElement)
        return null;
    return createPortal(React__default.createElement("div", { "data-zta": "shop-header-dark-overlay", "data-show": show, className: classNames(styles.darkOverlay, {
            [styles.darkOverlayShow]: show,
        }) }), portalElement);
};

export { DarkOverlay };
//# sourceMappingURL=DarkOverlay.js.map
